import { IMG } from "@/lib/content";
import { MaskedLines, Reveal } from "@/components/motion/Reveal";
import { Parallax } from "@/components/motion/Parallax";
import { Button } from "@/components/motion/Button";
import { useSettings } from "@/hooks/useData";

export function FinalCta() {
  const s = useSettings();
  return (
    <section className="relative min-h-[92svh] flex items-end text-paper" aria-labelledby="cta-title">
      <div className="absolute inset-0">
        <Parallax src={IMG.cta} alt="Lichtdurchfluteter Wohnraum" className="h-full" amount={8}>
          <div className="absolute inset-0 bg-ink/65" />
        </Parallax>
      </div>
      <div className="relative z-10 container-x py-28 md:py-36 w-full">
        <p className="label text-paper/50 mb-8 flex items-center gap-4"><span className="w-6 h-px bg-paper/40" /> 10 · Anfrage</p>
        <MaskedLines as="h2" id="cta-title" lines={["Was dürfen wir", "für Sie reinigen?"]} className="display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-paper" />
        <div className="mt-12 flex flex-col md:flex-row md:items-end justify-between gap-10">
          <Reveal delay={0.2}>
            <p className="max-w-md text-base md:text-lg text-paper/80 leading-relaxed">Schildern Sie uns kurz Ihr Anliegen. Wir melden uns mit einer passenden Lösung.</p>
          </Reveal>
          <Reveal delay={0.3} className="flex flex-wrap gap-4">
            <Button to="/kontakt" variant="light" data-testid="final-cta-offerte">Offerte anfragen</Button>
            <Button href={`tel:${s?.phone_link || ""}`} variant="outlineLight" data-testid="final-cta-call">Anrufen</Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
